import styled, { css } from 'styled-components';
import { Body2Styles } from '../../../typography';
import { getSizeBy, getColorShade, getColor } from '../../../../../src/styled/utils';
const FooterCellSharedCSS = css `
  position: sticky;
  bottom: 0;
`;
export const StyledFooterCell = styled.td `
  ${Body2Styles};
  ${FooterCellSharedCSS}
  padding: ${getSizeBy(4)} ${getSizeBy(2)};
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  font-weight: 600;
  white-space: nowrap;
  text-align: start;
  vertical-align: middle;
  background-color: ${getColor('surface')};
  box-shadow: inset 0 1px 0 ${getColorShade('onSurface', 'border')};

  &:first-child {
    padding-left: ${getSizeBy(4)};
  }

  &:last-child {
    padding-right: ${getSizeBy(4)};
  }
`;
